import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
  useParams,
  useLocation,
} from 'react-router-dom';
import { routes } from 'constants/config';
import { getQueryParam } from 'utils/url';
import useFetch from 'components/shared/hooks/useFetch';

const Module = ({ loading, title, stat }) => (
  <li className="StatisticsModule-stat">
    <span className="StatisticsModule-value">
      {loading ? <div className="Spinner" /> : stat}
    </span>
    <span className="StatisticsModule-label">{title}</span>
  </li>
);

const LessonEngagement = () => {
  const { search } = useLocation();
  const currentGroupId = getQueryParam(search, 'group_id');
  const { lessonId } = useParams();
  const { data, loading } = useFetch(
    routes.LESSON_OVERVIEW.ENGAGEMENT(lessonId, currentGroupId),
  );

  return (
    <ul className="StatisticsModule-list">
      <Module
        loading={loading}
        stat={data?.totalCompleted}
        title={t('lesson_analytics.lesson_engagement.lesson_completions')}
      />
      <Module
        loading={loading}
        stat={data?.totalLessonViews}
        title={t('lesson_analytics.lesson_engagement.lesson_views')}
      />
      <Module
        loading={loading}
        stat={data?.uniqueLessonViews}
        title={t('lesson_analytics.lesson_engagement.unique_learner_views')}
      />
      <Module
        loading={loading}
        stat={data?.averageCompletionTime}
        title={t('lesson_analytics.lesson_engagement.average_completion_time')}
      />
    </ul>
  );
};

const LessonEngagementRoot = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/lessons/:lessonId" component={LessonEngagement} />
      </Switch>
    </BrowserRouter>
  );
};

export default props => <LessonEngagementRoot {...props} />;
